import { env } from '@zopauk/nextjs-env';
import type { NextPageContext } from 'next';
import type { ErrorProps } from 'next/error';
import { default as NextError } from 'next/error';
import { ErrorPageTemplate } from '@zopauk/react-components';

const ZopaError = ({ statusCode }: ErrorProps) => (
  <ErrorPageTemplate>
    {statusCode === 404 ? (
      <ErrorPageTemplate.Four0Four linkUrl={env('NEXT_PUBLIC_WEBSITE_URL')} linkText="Go to Zopa home" />
    ) : (
      <ErrorPageTemplate.FiveHundred linkUrl={env('NEXT_PUBLIC_WEBSITE_URL')} />
    )}
  </ErrorPageTemplate>
);

ZopaError.getInitialProps = async (contextData: NextPageContext) => NextError.getInitialProps(contextData);

export default ZopaError;
